<app-info-text text="PERSONAL_DATA_PLAYER_PROFILE_MSG" color="text-gray-400"/>

<div class="formgrid grid pt-3">
  <div class="field col-6 md:col-3">
    <label for="firstname">{{'PERSON_FIRSTNAME' | translate}}</label>
    <input pInputText #inputFirstname id="firstname" type="text" class="p-inputtext w-full"
           [(ngModel)]="playerProfile.firstname" [maxlength]="100"
           (change)="playerProfile.firstname = optimizeName(playerProfile.firstname); updatePlayerProfileValue({ 'firstname': playerProfile.firstname}, inputFirstname); firstnameChanged()">
  </div>
  <div class="field col-6 md:col-3">
    <label for="lastname">{{'PERSON_LASTNAME' | translate}}</label>
    <input pInputText #inputLastname id="lastname" type="text" class="p-inputtext w-full"
           [(ngModel)]="playerProfile.lastname" [maxlength]="100"
           (change)="playerProfile.lastname = optimizeName(playerProfile.lastname); updatePlayerProfileValue({ 'lastname': playerProfile.lastname}, inputLastname)">
  </div>
  <div class="field col-6 md:col-3">
    <label for="gender">{{'PERSON_GENDER' | translate}}</label>
    <app-dropdown-domain class="w-full" id="gender"
                         [domainCd]="DOMAIN_GENDER" [domainValues]="DOMAIN_VALUES_GENDER"
                         [placeholder]="'PLEASE_SELECT' | translate"
                         [(value)]="playerProfile.genderCd" [showClear]="true"
                         (valueChange)="updatePlayerProfileValue({ 'genderCd': (playerProfile.genderCd === null ? '' : playerProfile.genderCd)})"/>
  </div>
  <div class="field col-6 md:col-3">
    <label for="nickname">{{'PERSON_NICKNAME' | translate}}</label>
    <input pInputText #inputNickname id="nickname" type="text" class="p-inputtext w-full"
           [(ngModel)]="playerProfile.nickname" [maxlength]="50"
           (change)="playerProfile.nickname = playerProfile.nickname.trim(); updatePlayerProfileValue({ 'nickname': playerProfile.nickname}, inputNickname)">
  </div>

  <div class="field col-6 md:col-4">
    <label for="street">{{'LOCATION_STREET_HOUSENUMBER' | translate}}</label>
    <input pInputText #inputStreet id="street" type="text" class="p-inputtext w-full"
           [(ngModel)]="playerProfile.street" [maxlength]="100"
           (change)="playerProfile.street = optimizeName(playerProfile.street); updatePlayerProfileValue({ 'street': playerProfile.street}, inputStreet)">
  </div>
  <div class="field col-6 md:col-2">
    <label for="zip">{{'LOCATION_ZIP' | translate}}</label>
    <input pInputText #inputZip id="zip" type="text" class="p-inputtext w-full"
           [(ngModel)]="playerProfile.postalCode" [maxlength]="15"
           (change)="playerProfile.postalCode = playerProfile.postalCode; updatePlayerProfileValue({ 'postalCode': playerProfile.postalCode}, inputZip)">
  </div>
  <div class="field col-6 md:col-3">
    <label for="city">{{'LOCATION_CITY' | translate}}</label>
    <input pInputText #inputCity id="city" type="text" class="p-inputtext w-full"
           [(ngModel)]="playerProfile.city" [maxlength]="100"
           (change)="playerProfile.city = optimizeName(playerProfile.city); updatePlayerProfileValue({ 'city': playerProfile.city}, inputCity)">
  </div>
  <div class="field col-6 md:col-3">
    <label for="country">{{'LOCATION_COUNTRY' | translate}}</label>
    <app-country-dropdown [(selectedCountryCd)]="playerProfile.countryCd"
                          (selectedCountryCdChange)="updatePlayerProfileValue({ 'countryCd': playerProfile.countryCd})"/>
  </div>

  <div class="field col-6 md:col-3">
    <label for="birthday">{{'PERSON_BIRTHDAY' | translate}}</label>
    <div class="flex align-items-center">
      <span>{{playerProfile.birthday | date: 'mediumDate'}}</span>
      @if (playerProfile?.birthdayChangeCount < 2) {
        <p-button styleClass="p-button-text" icon="pi pi-pencil" [label]="playerProfile.birthday ? '' : ('ACTION_EDIT' | translate)"
                  (click)="changeBirthday()"/>
      } @else {
        <p-button styleClass="p-button-text" icon="pi pi-lock"
                  [pTooltip]="'PLAYER_PROFILE_BIRTHDAY_CANNOT_BE_CHANGED' | translate" [showDelay]="400"/>
      }
    </div>
  </div>
  <div class="field col-6 md:col-3">
    <label for="mobile">{{'CONTACT_MOBILE' | translate}}</label>
    <input pInputText #inputMobil id="mobile" type="text" class="p-inputtext w-full"
           [(ngModel)]="playerProfile.mobil" [maxlength]="25"
           (change)="playerProfile.mobil = playerProfile.mobil.trim(); updatePlayerProfileValue({ 'mobil': playerProfile.mobil}, inputMobil)">
  </div>
  <div class="field col-6 md:col-3">
    <label for="phone">{{'CONTACT_PHONE' | translate}}</label>
    <input pInputText #inputPhone id="phone" type="text" class="p-inputtext w-full"
           [(ngModel)]="playerProfile.phone" [maxlength]="25"
           (change)="playerProfile.phone = playerProfile.phone.trim(); updatePlayerProfileValue({ 'phone': playerProfile.phone}, inputPhone)">
  </div>
</div>
